import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

/**
 * Buscar os dados
 *
 * @param {*} cod_ibge
 * @param {*} co_ubs
 * @param {*} mes
 * @param {*} ano
 * @param {*} tipo
 * @returns {Array}
 */
export async function getDados(cod_ibge, co_ubs, mes, ano, tipo) {
  try {
    let url = `/app/v2/bpa-i/${cod_ibge}/${co_ubs}/${mes}-${ano}`

    if (tipo != null) {
      url += `/${tipo.value}`
    }

    const { data } = await api.get(url)
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Busca os profissionais de saúde
 *
 * @param {*} cod_ibge
 * @param {*} co_ubs
 * @param {*} mes
 * @param {*} ano
 * @returns {Array}
 */
export async function getProfissionais(cod_ibge, co_ubs, mes, ano) {
  try {
    const { data } = await api.get(
      `/app/v2/bpa-i/${cod_ibge}/${co_ubs}/${mes}-${ano}/profissionais/saude`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Gera o relatório em PDF
 *
 * @param {*} cadastros
 * @param {*} cod_ibge
 * @param {*} co_ubs
 * @param {*} mes
 * @param {*} ano
 * @param {*} profissional
 */
export function generatePdf(
  cadastros,
  cod_ibge,
  co_ubs,
  mes,
  ano,
  profissional = null
) {
  let title_pdf = 'BPA-I'
  let titlePdfSave = `bpa_i-${mes}-${ano}`
  let description_pdf = 'Procedimentos Ambulatoriais Individualizados'
  let headers_pdf = ['']

  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}

    let nu_cns = cadastros[i].nu_cns || '                '
    let nu_cpf_cidadao = cadastros[i].nu_cpf_cidadao || '                '
    let no_cidadao = cadastros[i].no_cidadao || '                '
    let sexo = cadastros[i].sexo || '                '
    let dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) || '                '
    let nacionalidade =
      cadastros[i].nacionalidade || '____________________________'
    let raca_cor = cadastros[i].raca_cor || '_________________'
    let etnia = cadastros[i].etnia || '_________________'
    let ddd = cadastros[i].ddd || '_______'
    let telefone = cadastros[i].telefone || '___________________'
    let email = cadastros[i].email || '_______________________________________'
    let cep = cadastros[i].cep || '                '
    let ibge = cod_ibge

    let no_tipo_logradouro =
      cadastros[i].endereco.no_tipo_logradouro != null
        ? cadastros[i].endereco.no_tipo_logradouro
        : ''
    let ds_logradouro =
      cadastros[i].endereco.ds_logradouro != null
        ? cadastros[i].endereco.ds_logradouro
        : ''
    let nu_numero =
      cadastros[i].endereco.nu_numero != null
        ? `, ${cadastros[i].endereco.nu_numero}`
        : ''
    let ds_complemento =
      cadastros[i].endereco.ds_complemento != null
        ? `, ${cadastros[i].endereco.ds_complemento}`
        : ''
    let no_bairro =
      cadastros[i].endereco.no_bairro != null
        ? `, ${cadastros[i].endereco.no_bairro}`
        : ''

    let endereco = `${no_tipo_logradouro} ${ds_logradouro}${nu_numero}${ds_complemento}${no_bairro}`
    let dt_procedimento = utils.methods.formatDate(cadastros[i].dt_procedimento)
    let procedimento = cadastros[i].procedimento

    obj.dados = `    CPF PACIENTE: ${nu_cpf_cidadao} CNS PACIENTE: ${nu_cns}       PACIENTE: ${no_cidadao}\n
    SEXO: ${sexo}       NASCIMENTO: ${dt_nascimento}       NACIONALIDADE: ${nacionalidade}       RAÇA/COR: ${raca_cor}       ETNIA: ${etnia} \n
    CEP: ${cep}       IBGE: ${ibge}       ENDEREÇO: ${endereco}\n
    DDD:${ddd}       TELEFONE DE CONTATO: ${telefone}       E-MAIL: ${email}\n
    DATA DO PROCEDIMENTO: ${dt_procedimento}       CÓDIGO DO PROCEDIMENTO: ${procedimento}       QTDE:____       CNPJ:____________________________ \n
    SERVIÇO:_______        CLASS:_______        CID:________       CARÁTER DE ATENDIMENTO:____________________________        Nº DA AUTORIZAÇÃO:_______`

    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      const pageWidth = doc.internal.pageSize.getWidth()
      const marginXtext = pageWidth / 2

      doc.text(
        `IDENTIFICAÇÃO DO PROFISSIONAL`,
        marginXtext,
        verticalPosition,
        null,
        null,
        'center'
      )
      verticalPosition += 12

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mesAtual = String(data.getMonth() + 1).padStart(2, '0')
      let anoAtual = data.getFullYear()
      let dataAtual = dia + '/' + mesAtual + '/' + anoAtual

      doc.text(
        `PROFISSIONAL: ${profissional.no_prof}\nMÊS/ANO: ${mes}/${ano}    \nDATA: ${dataAtual}`,
        15,
        verticalPosition,
        null,
        null,
        'left'
      )
      verticalPosition += 16

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
